import React, { useEffect, useState } from 'react';

function getColumnCount() {
  if (typeof window === 'undefined') return 3;
  const w = window.innerWidth;
  if (w <= 768) return 1;
  if (w <= 1200) return 2;
  return 3;
}

/**
 * Renders investigation section cards into parallel vertical columns (round-robin) so one
 * expanded accordion does not inflate row height across the whole SecurityTrails grid.
 * Replaces CSS Grid row alignment for this dense card layout (see index.css).
 */
export default function InvestigationSectionGrid({ children }) {
  const [columnCount, setColumnCount] = useState(getColumnCount);

  useEffect(() => {
    const update = () => setColumnCount(getColumnCount());
    window.addEventListener('resize', update);
    update();
    return () => window.removeEventListener('resize', update);
  }, []);

  const items = React.Children.toArray(children).filter((child) => child != null && child !== false);
  const cols = Array.from({ length: columnCount }, () => []);
  items.forEach((child, i) => {
    cols[i % columnCount].push(child);
  });

  return (
    <div className="investigation-grid-columns" role="presentation">
      {cols.map((cells, idx) => (
        <div key={idx} className="investigation-grid-col">
          {cells}
        </div>
      ))}
    </div>
  );
}
